import SectionHeading from '../../../components/SectionHeading'
import Content from './Content'

const SecOurServices = ({data}) => {

  return (
    <section className="our_services_area section-padding-100-70 clearfix" id="services">
        <div className="container">
            
            <SectionHeading
                title='Green Earth Ecosystem'
                text='You can view the key components of our ecosystem.'
            />
                

            <div className="row">
                {data && data.map((item , key) => (
                    <Content
                        key={key}
                        img={item.img}
                        title={item.title}
                        description={item.description}
                    />
                ))}
            </div>
        </div>
    </section>
  );
}

export default SecOurServices;